import { render } from "./homeDesktop.vue?vue&type=template&id=79d3b0c1"
import script from "./homeDesktop.vue?vue&type=script&lang=js"
export * from "./homeDesktop.vue?vue&type=script&lang=js"

import "../assets/css/refonte.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__